module.exports = __webpack_public_path__ + "img/home-background.98f0c9fd.png";